import PrivateLayout from "@/components/layouts/private-layout";
import AdminProfile from "@/pages/profile";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <AdminProfile />
    </PrivateLayout>
  );
}
